import AlertBarPaymentError from './AlertBarPaymentError'

export default AlertBarPaymentError
// eslint-disable-next-line import/export
export * from './AlertBarPaymentError'
